(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["milanus-product-discovery"]) return;
  try {
    
  document.querySelectorAll('[data-product-discovery]').forEach(function (section) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-discovery-page]'));
    var previous = section.querySelector('[data-discovery-previous]');
    var next = section.querySelector('[data-discovery-next]');
    var status = section.querySelector('[data-discovery-status]');
    var shopAll = section.querySelector('[data-discovery-shop-all]');
    var pageCount = Number(section.getAttribute('data-discovery-page-count')) || 1;
    var currentPage = 0;
    var nextPageLabel = next.getAttribute('aria-label');

    function showPage(page, direction) {
      currentPage = Math.max(0, Math.min(page, pageCount - 1));
      cards.forEach(function (card) {
        card.hidden = Number(card.getAttribute('data-discovery-page')) !== currentPage;
      });
      previous.disabled = currentPage === 0;
      next.disabled = false;
      next.setAttribute('aria-label', currentPage === pageCount - 1 && shopAll ? shopAll.textContent.trim() : nextPageLabel);
      status.textContent = String(currentPage + 1) + ' / ' + String(pageCount);
      if (direction && typeof window.milanusTrack === 'function') {
        window.milanusTrack('milanus_product_discovery_paginated', {
          direction: direction,
          discovery_page: currentPage + 1,
          products_visible: cards.filter(function (card) { return !card.hidden; }).length
        });
      }
    }

    previous.addEventListener('click', function () { showPage(currentPage - 1, 'previous'); });
    next.addEventListener('click', function () {
      if (currentPage === pageCount - 1 && shopAll) {
        if (typeof window.milanusTrack === 'function') {
          window.milanusTrack('milanus_product_discovery_paginated', { direction: 'shop_all', discovery_page: currentPage + 1, products_visible: 4 });
        }
        window.location.assign(shopAll.href);
        return;
      }
      showPage(currentPage + 1, 'next');
    });
    showPage(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milanus-product-recommendations"]) return;
  try {
    
  document.querySelectorAll('[data-milanus-recommendations]').forEach(function (section) {
    if (section.dataset.kitCarouselReady === 'true') return;
    section.dataset.kitCarouselReady = 'true';
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-kit-page]'));
    var previous = section.querySelector('[data-kit-previous]');
    var next = section.querySelector('[data-kit-next]');
    var status = section.querySelector('[data-kit-status]');
    var shopAll = section.querySelector('[data-kit-shop-all]');
    var pageCount = Number(section.getAttribute('data-kit-page-count')) || 1;
    var currentPage = 0;
    var nextPageLabel = next.getAttribute('aria-label');

    function showPage(page, direction) {
      currentPage = Math.max(0, Math.min(page, pageCount - 1));
      cards.forEach(function (card) {
        card.hidden = Number(card.getAttribute('data-kit-page')) !== currentPage;
      });
      previous.disabled = currentPage === 0;
      next.disabled = false;
      next.setAttribute('aria-label', currentPage === pageCount - 1 && shopAll ? shopAll.textContent.trim() : nextPageLabel);
      status.textContent = String(currentPage + 1) + ' / ' + String(pageCount);
      if (direction && typeof window.milanusTrack === 'function') {
        window.milanusTrack('milanus_product_recommendations_page', {
          direction: direction,
          recommendation_page: currentPage + 1,
          products_visible: cards.filter(function (card) { return !card.hidden; }).length,
          recommendation_source: 'kits_best_selling'
        });
      }
    }

    previous.addEventListener('click', function () { showPage(currentPage - 1, 'previous'); });
    next.addEventListener('click', function () {
      if (currentPage === pageCount - 1 && shopAll) {
        if (typeof window.milanusTrack === 'function') {
          window.milanusTrack('milanus_product_recommendations_page', { direction: 'shop_all', recommendation_page: currentPage + 1, products_visible: 4, recommendation_source: 'kits_best_selling' });
        }
        window.location.assign(shopAll.href);
        return;
      }
      showPage(currentPage + 1, 'next');
    });
    showPage(0);
    window.setTimeout(function () {
      section.dispatchEvent(new CustomEvent('milanus:recommendations:loaded', { bubbles: true }));
    }, 0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milanus-wholesale-bangles-collection"]) return;
  try {
    
document.querySelectorAll('[data-wgb-product]').forEach(function(root){
  var thumbs=Array.from(root.querySelectorAll('[data-wgb-thumb]'));
  var main=root.querySelector('.wgb-product__main-image');
  var activeIndex=Math.max(0,thumbs.findIndex(function(thumb){return thumb.classList.contains('is-active')}));
  function showImage(index){
    if(!main||!thumbs.length){return}
    activeIndex=(index+thumbs.length)%thumbs.length;
    var thumb=thumbs[activeIndex];
    main.src=thumb.dataset.imageSrc;
    main.srcset=thumb.dataset.imageSrcset||'';
    main.alt=thumb.dataset.imageAlt||'';
    thumbs.forEach(function(item){item.classList.toggle('is-active',item===thumb)});
    thumb.scrollIntoView({block:'nearest',inline:'nearest'});
  }
  thumbs.forEach(function(thumb,index){thumb.addEventListener('click',function(){showImage(index)})});
  var previous=root.querySelector('[data-wgb-gallery-previous]');
  var next=root.querySelector('[data-wgb-gallery-next]');
  if(previous){previous.addEventListener('click',function(){showImage(activeIndex-1)})}
  if(next){next.addEventListener('click',function(){showImage(activeIndex+1)})}
  var selector=root.querySelector('[data-wgb-variant]');
  var idInput=root.querySelector('[data-wgb-variant-id]');
  var price=root.querySelector('[data-wgb-price]');
  var compare=root.querySelector('[data-wgb-compare]');
  var sku=root.querySelector('[data-wgb-sku]');
  var submit=root.querySelector('[data-wgb-submit]');
  var submitText=root.querySelector('[data-wgb-submit-text]');
  function updateVariant(){
    if(!selector){return}
    var option=selector.options[selector.selectedIndex];
    idInput.value=option.value;
    price.textContent=option.dataset.price;
    compare.textContent=option.dataset.compare||'';
    compare.classList.toggle('is-hidden',!option.dataset.compare);
    sku.textContent=option.dataset.sku||'—';
    var available=option.dataset.available==='true';
    submit.disabled=!available;
    submitText.textContent=available?submit.dataset.availableText:submit.dataset.soldOutText;
    if(option.dataset.imageId){
      var index=thumbs.findIndex(function(thumb){return thumb.dataset.imageId===option.dataset.imageId});
      if(index>-1){showImage(index)}
    }
  }
  if(selector){selector.addEventListener('change',updateVariant)}
  var quantity=root.querySelector('[data-wgb-quantity]');
  root.querySelectorAll('[data-wgb-quantity-change]').forEach(function(button){
    button.addEventListener('click',function(){
      var nextValue=Math.max(1,(parseInt(quantity.value,10)||1)+parseInt(button.dataset.wgbQuantityChange,10));
      quantity.value=nextValue;
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
